export const nl = {
    "TRIGGER_LISTEN": "Luisteren naar triggers",
    "ASSIST_EMPTY_MSG": "Agent AI luistert actief naar je gesprek en is klaar om automatisch te helpen wanneer dit wordt getriggerd.",
    "MYBOT_TRIGGET_LISTEN": "Momenteel geen actieve My Bot-taken",
    "MYBOT_EMTPY_MSG": "Om een taak in My Bot te starten, ga naar het tabblad zoeken en selecteer de optie \"\"Uitvoeren met agent invoer\"\" voor de gewenste taak.",
    "PROACTIVE_MODE": "Proactieve modus",
    "SETTINGS": "Instellingen",
    "HELP_AND_SUPPORT": "Help & Ondersteuning",
    "HELP": "Help",
    "LANGUAGE": "Taal",
    "THEME": "Thema",
    "AUTOMATIC": "Automatisch",
    "DARK": "Donker",
    "LIGHT": "Licht",
    "FILE_NAME":"Bestandsnaam",
    "AUTO_SCROLL_TOOLTIP":"Beheert het automatisch scrollen van het Assist-tabblad, Mijn bot en de inhoud van het Transcript-tabblad",
    "THEME_DESC": "Dit zal de standaardmodus van je systeem gebruiken",
    "DOCUMENTATION": "Documentatie",
    "DOC_DESC": "Bekijk onze uitgebreide documentatieartikelen.",
    "FAQ_U": "Veelgestelde Vragen",
    "FAQ_DESC": "Bekijk veelgestelde vragen over Agent AI.",
    "KORE_ACADEMY": "Kore Academie",
    "KORE_ACA_DESC": "Leer meer over Agent AI door de cursussen van de academie te volgen.",
    "SEARCH": "Zoeken",
    "TAB_TEXT":"Geen tabbladen ingeschakeld! Schakel ten minste één tabblad in",
    "MY_BOT": "Mijn Bot",
    "ASSIST": "Assistentie",
    "TRANSCRIPT": "Transcript",
    "HISTORY": "Geschiedenis",
    "STARTOVER": "Opnieuw beginnen",
    "RESTART_INPUTS": "Herstarten met vastgelegde invoer",
    "ASKCUSTOMER": "Vraag Klant",
    "TELLCUSTOMER": "Vertel Klant",
    "WELCOME_MSG": "Welkomstbericht",
    "SEND": "Versturen",
    "SENT": "Verzonden",
    "TAP_SEARCH":"Tik om te zoeken",
    "AWAITING": "Wachten op antwoord | Typ om verder te gaan",
    "OVERRIDE": "Typ om verder te gaan",
    "OVERRIDE_FILE": "Voeg bestand bij om verder te gaan",
    "ACCEPT_RESPONSE": "Antwoord Geaccepteerd",
    "AGENT_ENTERED": "Agent Ingevoerd",
    "EXPECTED_FORMAT": "Verwacht Formaat",
    "INPUT_VALUES": "Invoergegevens",
    "RESTART": "Herstarten",
    "START_OVER": "Opnieuw beginnen",
    "RESTART_CAPTURE": "Herstarten met vastgelegde invoer",
    "CANCEL": "Annuleren",
    "INTERRUPT_DIALOG": "ONDERBROKEN DIALOOGTAKEN",
    "RUN": "UITVOEREN",
    "RUN_AGENT": "Uitvoeren met invoer van agent",
    "STEP": "Stap",
    "DIALOG_TASK": "Dialoogtaak",
    "FAQ": "Veelgestelde Vragen",
    "SNIPPET": "Antwoorden",
    "ARTICLE": "Webpagina's",
    "FILE": "Bestanden",
    "SUGGESTED": "Voorgesteld",
    "ALL_DIALOG": "Alle Dialoogtaken",
    "DIALOG_TEXT": "Dialoog",
    "INTENT_IDENTIFIED": "Klantuitspraak",
    "NOT_WHAT_LOOKING": "Verkeerde Suggestie?",
    "BOT": "Bot",
    "CUSTOMER": "Klant",
    "YOU": "Jij",
    "TERMINATE_CONV": "Dialoogtaak Beëindigen",
    "TERMINATE_CONV_DESC": "Weet je zeker dat je de dialoogtaak wilt beëindigen? Agent AI zal geen suggesties meer kunnen doen.",
    "YES_TERMINATE": "Ja, Beëindigen",
    "NO_CANCEL": "Nee, Annuleren",
    "OVERRIDE_CONTINUE": "Doorgaan met override modus",
    "SUMMARY_TEXT": "Samenvatting",
    "SUBMIT": "Indienen",
    "INTERRUPT_OCCURED": "Onderbreking Opgetreden",
    "IDENTIFIED_INTENT": "Geïdentificeerde intentie",
    "INTERRUPT_DESC": "Door dit uit te voeren beëindig je je lopende dialoogtaak.",
    "ACCEPT_RUN": "Accepteren en Uitvoeren",
    "RUN_LATER": "Later Uitvoeren",
    "KNOW_MORE": "Meer Weten",
    "MORE_TEXT": "Meer",
    "LESS_TEXT": "Minder",
    "VIEW_MORE": "Bekijk Meer",
    "VIEW_LESS": "Bekijk Minder",
    "SHOW_MORE_FAQ": "Toon meer Veelgestelde Vragen",
    "SHOW_LESS_FAQ": "Toon minder Veelgestelde Vragen",
    "SHOW_MORE_ARTICLE": "Toon meer webpagina's",
    "SHOW_LESS_ARTICLE": "Toon minder webpagina's",
    "SHOW_MORE_SNIPPET": "Toon meer Antwoorden",
    "SHOW_LESS_SNIPPET": "Toon minder Antwoorden",
    "SHOW_MORE_FILES": "Toon Meer Bestanden",
    "SHOW_LESS_FILES": "Toon Minder Bestanden",
    "VIEW_ALL_DIALOG": "Bekijk alle Dialogen",
    "VIEW_FEW_DIALOG": "Bekijk enkele Dialogen",
    "HELP_FULL": "Nuttig?",
    "THANKYOU": "Dank je!",
    "EXPAND_MORE": "Uitvouwen / Meer",
    "CLOSE_TEXT": "Sluiten",
    "STARTED": "Gestart",
    "ENDED": "geëindigd",
    "VIEW_FULL_ARTICLE": "Bekijk webpagina",
    "VIEW_FULL_FILE": "Bekijk bestand",
    "COPIED": "Gekopieerd",
    "SENTI_ANALY": "Sentimentanalyse",
    "WRONG_SUGGESTION": "Verkeerde suggesties",
    "INCORRECT_INTENT": "Onjuiste intentie",
    "ACCIDENTAL_CLICK": "Per ongeluk geklikt",
    "TIME_TAKING": "Tijdrovend",
    "OTHER": "Anders",
    "PLAYBOOK_EMPTY_MSG": "Selecteer Playbook",
    "PLAYBOOK_EMPTY_DESC": "Agent AI kan het playbook niet laden omdat alle beschikbare playbooks dynamisch zijn. Klik op 'Selecteer Playbook' om toegang te krijgen tot het playbook.",
    "STAGE": "Fase",
    "PROCEED_TO_CLOSE": "Doorgaan met sluiten",
    "RECOMENDED_PLAYBOOK": "AANBEVOLEN PLAYBOOK",
    "PRIMARY_SCRIPTS": "PRIMAIRE SCRIPTS",
    "DYNAMIC_SCRIPTS": "DYNAMISCHE SCRIPTS",
    "RESUME": "Hervatten",
    "ENABLE_CLOSE": "Klik op de knop doorgaan met sluiten om de Sluit Fase in te schakelen.",
    "LIST_VIEW": "Lijstweergave",
    "TERMINATE": "Beëindigen",
    "MINIMIZE": "Minimaliseren",
    "MAXIMIZE": "Maximaliseren",
    "NO_SEARCH_RESULT": "Geen zoekresultaat gevonden",
    "SENTIMENT_AWAITING": "Wachten op sentiment",
    "POSITIVE": "Pos",
    "NEGATIVE": "Neg",
    "ASSOCIATED_WORK_NOTES": "Eerdere Oplossingsnotities",
    "AGENT_JOINED_CONV": "Agent voegde zich bij het gesprek",
    "AUTOSCROLL_ASSIST": "Auto-scroll assist tab inhoud",
    "FILE_SIZE_MSG": "Bestandsgrootte moet binnen 25MB zijn. Probeer opnieuw.",
    "OVERRIDE_BTN": "Override",
    "CHOOSE_FILE": "Kies Bestand",
    "SUMMARY_ERROR_TEXT": "Sorry, er was een probleem bij het genereren van de samenvatting voor dit gesprek. Maak alstublieft je eigen samenvatting.",
    "ASK_A_QUESTION": "Stel een vraag",
    "COPY" : "Kopiëren",
    "PLAYBOOK": "Playbook",
    "TELL_US_MORE": "Vertel ons meer",
    "THANKS_FEEDBACK": "Bedankt voor je feedback",
    "SOMETHING_WRONG": "Er is iets fout gegaan",
    "CLICK_ERROR_DETAILS": "Klik voor foutdetails",
    "NO_ACTIVE_PLAYBOOK": "Geen actief playbook",
    "REPHRASE_QUESTION": "Kun je je vraag herformuleren of iets anders vragen?",
    "INTERNAL_INFO": "Interne informatie",
    "SOURCES": "Bronnen",
    "CONVERSATION_SUMMARY": "Samenvatting van het gesprek",
    "WAITING": "Wachten",
    "WIDGET_DISABLED": "Widget is uitgeschakeld",
    "AI_SETTINGS_DISABLED": "AI-instellingen zijn uitgeschakeld! Neem contact op met de AI-beheerder",
    "SERVER_CONNECTION_ERROR": "Fout bij verbinding maken met de server",
    "VIEW": "Bekijk",
    "ATTACHMENT_INPUT": "Bijlage-invoer",
    "TYPE_SUMMARY": "Typ samenvatting",
    "VIEW_FULL_ARTICLE_2": "Bekijk het volledige artikel",
    "VIEW_FULL_FILE_2": "Bekijk het volledige bestand",
    "BY":"Door",
    GENERATE_SUMMARY: "Samenvatting genereren",
    PREV_SUMMARIES: "Eerder gegenereerde samenvattingen",
    DIALOG_WORKFLOWS: "Dialoog Workflows",
    SHOW_ALL_DIALOG: "Toon alle Dialoog Taken",
    SHOW_ALL_DIALOGS: "Toon Alle Dialogen",
    CUSTOM_TAB: "Aangepast Tabblad",
    AGENT_INPUT: "Agent Invoer",
    "CUSTOM_EMPTY_MSG" : "Geen actieve workflow momenteel",
    "CUSTOM_TAB_DESC" : "Om een workflow te starten, voer een van de lijsten uit die aan de onderkant van het scherm aanwezig zijn.",
    "SUBMIT_OVERALL_FEEDBACK" : "Algemene feedback indienen",
    "FEEDBACK_POPUP_SUBTITLE" : "Feedback over de widget en haar functionaliteiten",
    "FEEDBACK_SATISFIED" : "Voldoet",
    "FEEDBACK_UNSATISFIED" : "Voldoet niet",
    "FEEDBACK_PROVIDE_REASONS" : "Meer informatie geven…",
    "FEEDBACK_TITLE" : "Feedback",
    "AGENTIC_THINKING" : "Denkt",
    "AGENTIC_AGENT_TITLE" : "Agent",
    "AGENTIC_COPILOT_MODE_TITLE" : "Agentic Copilot-modus",
    "AGENTIC_SENDING_MESSAGE" : "Verzenden...",
    "AGENTIC_COPILOT_DESC" : "Agentic Copilot luistert actief naar uw gesprek en is klaar om automatisch te assisteren",
    "AGENTIC_SEARCH_RESULTS" : "Agent Resultaten",
    "PAUSE_AUTO_SEND" : "Automatisch verzenden pauzeren",
    "PAUSE_AGENTIC" : "Agent pauzeren",
    "RESUME_AGENTIC" : "Agent hervatten",
    "RESUME_AUTO_SEND" : "Automatisch verzenden hervatten"
}